import { OverlayModule } from "@angular/cdk/overlay";
import { DatePipe } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDialogModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
} from "@angular/material";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import { TextMaskModule } from "angular2-text-mask";
import { QRCodeModule } from "angularx-qrcode";
import { RecaptchaModule } from "ng-recaptcha";
import { TourNgxPopperModule, TourService } from "ngx-tour-ngx-popper";
import { AppComponent } from "./app.component";
import { AtivacaoEtokenTerceirosComponent } from "./ativacao-etoken-terceiros/ativacao-etoken-terceiros.component";
import { AtivacaoComponent } from "./ativacao/ativacao.component";
import { AlterarUsuarioComponent } from "./cadastro/alterar-usuario/alterar-usuario.component";
import { CadastroUsuariosLoteComponent } from "./cadastro/cadastro-usuarios-lote/cadastro-usuarios-lote.component";
import { NovoCadastroComponent } from "./cadastro/novo-cadastro/novo-cadastro.component";
import { CertificadoFormComponent } from "./certificado/certificado-form/certificado-form.component";
import { CertificadoListComponent } from "./certificado/certificado-list/certificado-list.component";
import { ConfirmaRedefinicaoPinComponent } from "./confirma-redefinicao-pin/confirma-redefinicao-pin.component";
import { ConfirmarEmissaoComponent } from "./confirmar-emissao/confirmar-emissao.component";
import { EmailAtivacaoComponent } from "./email-ativacao/email-ativacao.component";
import { EmissaoRenovacaoComponent } from "./emissao-renovacao/emissao-renovacao.component";
import { EtokenParaVoceComponent } from "./etoken/etoken-para-voce/etoken-para-voce.component";
import { EtokenTerceirosComponent } from "./etoken/etoken-terceiros/etoken-terceiros.component";
import { EtokenComponent } from "./etoken/etoken.component";
import { CadastroPinComponent } from "./fatores-autenticacao/cadastro-pin/cadastro-pin.component";
import { CadastroTokenOtpComponent } from "./fatores-autenticacao/cadastro-token-otp/cadastro-token-otp.component";
import { EditarPinComponent } from "./fatores-autenticacao/editar-pin/editar-pin.component";
import { ExibirCodigoChaveComponent } from "./fatores-autenticacao/exibir-codigo-chave/exibir-codigo-chave.component";
import { FatoresAutenticacaoComponent } from "./fatores-autenticacao/fatores-autenticacao.component";
import { RecuperacaoPinCodigoChaveComponent } from "./fatores-autenticacao/recuperacao-pin-codigo-chave/recuperacao-pin-codigo-chave.component";
import { RecuperacaoPinComponent } from "./fatores-autenticacao/recuperacao-pin/recuperacao-pin.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { HistoricoUsoComponent } from "./historico-uso/historico-uso.component";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { LogoutInterceptor } from "./logout.interceptor";
import { NovoUsuarioComponent } from "./novo-usuario/novo-usuario.component";
import { RedefinicaoEmailComponent } from "./redefinicao-email/redefinicao-email.component";
import { RedefinicaoOtpComponent } from "./redefinicao-otp/redefinicao-otp.component";
import { RedefinicaoPinComponent } from "./redefinicao-pin/redefinicao-pin.component";
import { RelatorioComponent } from "./relatorio/relatorio.component";
import { RenovacaoCertificadoComponent } from "./renovacao-certificado/renovacao-certificado.component";
import { RenovacaoComponent } from "./renovacao/renovacao.component";
import { ResetSenhaComponent } from "./reset-senha/reset-senha/reset-senha.component";
import { SegurancaComponent } from "./seguranca/seguranca.component";
import { CampoControlErroComponent } from "./shared/campo-control-erro/campo-control-erro.component";
import { ConfirmDialogComponent } from "./shared/confirm-dialog/confirm-dialog.component";
import { EqualValidator } from "./shared/directives/equal-validator.directive";
import { PoliticaSenhaResolve } from "./shared/resolve/politica-senha.resolve";
import { UsuarioResolve } from "./shared/resolve/usuario.resolve";
import { AtivacaoService } from "./shared/service/ativacao/ativacao.service";
import { AuthGuard } from "./shared/service/auth/auth-guard.service";
import { AuthModule } from "./shared/service/auth/auth.module";
import { CertificadoComunicacaoService } from "./shared/service/certificado-comunicacao/certificado-comunicacao.service";
import { CertificadoService } from "./shared/service/certificado/certificado.service";
import { ConfirmDialogService } from "./shared/service/confirm-dialog/confirm-dialog.service";
import { LoginService } from "./shared/service/login/login.service";
import { RelatoriosService } from "./shared/service/relatorios/relatorios.service";
import { RenovacaoService } from "./shared/service/renovacao/renovacao.service";
import { SegurancaService } from "./shared/service/seguranca/seguranca.service";
import { SolicitacoesService } from "./shared/service/solicitacoes/solicitacoes.service";
import { TokenService } from "./shared/service/token/token.service";
import { UsuarioService } from "./shared/service/usuario/usuario.service";
import { TermoListComponent } from "./shared/termo-list/termo-list.component";
import { TourInterativo } from "./shared/Tour/TourInterativo";
import { SolicitacaoCertificadoComponent } from "./solicitacao-certificado/solicitacao-certificado.component";
import { SolicitacoesListComponent } from "./solicitacoes-list/solicitacoes-list.component";
import { UsuarioListComponent } from "./usuario/usuario-list/usuario-list.component";
import { UsuarioResetTokenComponent } from "./usuario/usuario-reset-token/usuario-reset-token.component";

const publicRoutes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "ativacao/:token", component: AtivacaoComponent },
  { path: "resetOtp/:token", component: RedefinicaoOtpComponent },
  {
    path: "ativacaoetokenterceiros/:token",
    component: AtivacaoEtokenTerceirosComponent,
  },
  { path: "redefinicao-email/:token", component: RedefinicaoEmailComponent },
  { path: "novo-cadastro", component: NovoCadastroComponent },
  { path: "email-ativacao", component: EmailAtivacaoComponent },
  { path: "resetSenha/:token", component: ResetSenhaComponent },
  {
    path: "renovacao-certificado/:desafio",
    component: RenovacaoCertificadoComponent,
  },
  {
    path: "redefinicaopin/:codigoAutenticacao",
    component: ConfirmaRedefinicaoPinComponent,
  },
  {
    path: "confirmaremissao/:codigoAutenticacao",
    component: ConfirmarEmissaoComponent,
  },
];

const loggedRoutes: Routes = [
  {
    path: "lista-usuario",
    component: UsuarioListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "renovacoes",
    component: RenovacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "novo-usuario",
    component: NovoUsuarioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "usuarios-lote",
    component: CadastroUsuariosLoteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "reset-token",
    component: UsuarioResetTokenComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "carteira-certificado",
    component: CertificadoListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "solicitacoes",
    component: SolicitacoesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "certificado-form",
    component: CertificadoFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "certificado-form/:id",
    component: CertificadoFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorios",
    component: RelatorioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "historico-uso",
    component: HistoricoUsoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "etoken",
    component: EtokenComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "alterar-usuario",
    component: AlterarUsuarioComponent,
    canActivate: [AuthGuard],
    resolve: {
      obterDadosUsuario: UsuarioResolve,
    },
  },
  {
    path: "solicitar-certificado",
    component: SolicitacaoCertificadoComponent,
    canActivate: [AuthGuard],
    resolve: {
      obterDadosUsuario: UsuarioResolve,
    },
  },
  {
    path: "seguranca",
    component: SegurancaComponent,
    canActivate: [AuthGuard],
    resolve: {
      obterPoliticaSenha: PoliticaSenhaResolve,
    },
  },
  {
    path: "fatores",
    component: FatoresAutenticacaoComponent,
    canActivate: [AuthGuard],
    resolve: {
      obterPoliticaSenha: PoliticaSenhaResolve,
    },
  },
  {
    path: "emitir-renovacao",
    component: EmissaoRenovacaoComponent,
    canActivate: [AuthGuard],
    resolve: {
      obterDadosUsuario: UsuarioResolve,
    },
  },
];
const appRoutes: Routes = [
  ...publicRoutes,
  ...loggedRoutes,
  // otherwise redirect to login
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "**", redirectTo: "" },
];

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    HomeComponent,
    AtivacaoComponent,
    EqualValidator,
    NovoUsuarioComponent,
    FatoresAutenticacaoComponent,
    SolicitacaoCertificadoComponent,
    CertificadoListComponent,
    CertificadoFormComponent,
    SolicitacoesListComponent,
    UsuarioListComponent,
    RenovacaoComponent,
    RenovacaoCertificadoComponent,
    SegurancaComponent,
    CampoControlErroComponent,
    UsuarioResetTokenComponent,
    NovoCadastroComponent,
    RedefinicaoPinComponent,
    ConfirmaRedefinicaoPinComponent,
    RelatorioComponent,
    AlterarUsuarioComponent,
    RedefinicaoOtpComponent,
    ResetSenhaComponent,
    RedefinicaoEmailComponent,
    CadastroPinComponent,
    RecuperacaoPinComponent,
    CadastroTokenOtpComponent,
    HistoricoUsoComponent,
    EmissaoRenovacaoComponent,
    EtokenComponent,
    EtokenParaVoceComponent,
    EtokenTerceirosComponent,
    EmailAtivacaoComponent,
    AtivacaoEtokenTerceirosComponent,
    CadastroUsuariosLoteComponent,
    ConfirmarEmissaoComponent,
    ConfirmDialogComponent,
    RecuperacaoPinCodigoChaveComponent,
    ExibirCodigoChaveComponent,
    EditarPinComponent,
    TermoListComponent,
  ],
  exports: [ConfirmDialogComponent],
  entryComponents: [
    CampoControlErroComponent,
    EtokenParaVoceComponent,
    EtokenTerceirosComponent,
    CadastroTokenOtpComponent,
    ConfirmDialogComponent,
    TermoListComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    TextMaskModule,
    RouterModule.forRoot(appRoutes, { useHash: true }),
    HttpClientModule,
    AuthModule,
    QRCodeModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatIconModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatSnackBarModule,
    MatGridListModule,
    MatTabsModule,
    OverlayModule,
    TourNgxPopperModule.forRoot(),
    RecaptchaModule,
  ],
  providers: [
    AuthGuard,
    AtivacaoService,
    UsuarioResolve,
    LoginService,
    UsuarioService,
    RenovacaoService,
    CertificadoService,
    SolicitacoesService,
    CertificadoComunicacaoService,
    SegurancaService,
    PoliticaSenhaResolve,
    TokenService,
    RelatoriosService,
    DatePipe,
    TourInterativo,
    TourService,
    ConfirmDialogService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LogoutInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
